export class UserModel {
  id: number;
  mail: string;
  name: string;
  lastname: string;
  password: string;
  role: string;
}
